import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import AutoQuery from "servicestack/auto-query/auto-query";

export default class CustomerNotesPopupController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    $ctrl.config = cartConfig;
    $ctrl.customer = Object.assign({}, options.model, options.customer);
    $ctrl.locationmode = options.locationmode;
    $ctrl.customersQuery = new AutoQuery({
      url: "QueryRetailers.json?Id=" + $ctrl.customer.id,
      autoLoad: true,
      pageSize: 10,
      onLoaded: args => {
        $ctrl.customer = args.first;
      }
    });
    if ($ctrl.locationmode) {
      $ctrl.locationQuery = new AutoQuery({
        url: "QueryRetailerShippingLocations?Id=" + $ctrl.customer.id,
        autoLoad: true,
        pageSize: 10,
        onLoaded: args => {
          $ctrl.customer = args.first;
        }
      })
    }
    $ctrl.title = options.title || $ctrl.locationmode ? "Location Notes" : "Customer Notes";
  }
}
